import { debounce } from "@github/mini-throttle";
import { envConfig } from "../config/envConfigs";
import { format } from "./format";

let batch: unknown[] = [];
const flush = debounce(() => {
  fetch(envConfig.urls.logger, { body: JSON.stringify(batch), method: "POST" });
  batch = [];
}, 1000);

export type LogMessage = {
  event?: "measure";
  string: unknown;
};
export const log = (message: LogMessage): void => {
  batch.push(format(message));
  flush();
};
